import { http } from './request'
import { sm2Encrypt } from '@/utils/crypto'

const PREFIX = '/sys/userCenter'

export interface UpdateUserInfoPayload {
  id: string
  name: string
  phone: string
  /** 登录密码明文，请求时 SM2 加密 */
  password: string
}

/** POST /sys/userCenter/updateUserInfo */
export async function updateUserInfo(payload: UpdateUserInfoPayload): Promise<void> {
  await http.post<void>(`${PREFIX}/updateUserInfo`, {
    id: payload.id,
    name: payload.name.trim(),
    phone: payload.phone.trim(),
    password: sm2Encrypt(payload.password),
  })
}

/** POST /sys/userCenter/updateAvatar（multipart/form-data, RequestPart file） */
export async function updateAvatar(file: File): Promise<string> {
  const fd = new FormData()
  fd.append('file', file)
  return http.upload<string>(`${PREFIX}/updateAvatar`, fd)
}

export async function updatePasswordByOldPassword(payload: {
  password: string
  newPassword: string
}): Promise<void> {
  await http.post<void>(`${PREFIX}/updatePassword`, {
    password: sm2Encrypt(payload.password),
    newPassword: sm2Encrypt(payload.newPassword),
  })
}

/** GET /sys/userCenter/getPicCaptcha（与 findPassword* 共用 user-validCode 缓存前缀） */
export async function fetchUserCenterPicCaptcha(): Promise<unknown> {
  return http.get<unknown>(`${PREFIX}/getPicCaptcha`)
}

/**
 * 找回/修改密码：获取手机短信验证码
 * 须配合 {@link fetchUserCenterPicCaptcha}，缓存前缀均为 user-validCode:
 */
export async function findPasswordGetPhoneValidCode(payload: {
  phone: string
  userMode: number
  validCode: string
  validCodeReqNo: string
}): Promise<string> {
  return http.get<string>(`${PREFIX}/findPasswordGetPhoneValidCode`, { params: payload })
}

export async function resetPasswordByPhone(payload: {
  phone: string
  userMode: number
  validCode: string
  validCodeReqNo: string
  newPassword: string
}): Promise<void> {
  await http.post<void>(`${PREFIX}/findPasswordByPhone`, {
    phone: payload.phone,
    userMode: payload.userMode,
    validCode: payload.validCode,
    validCodeReqNo: payload.validCodeReqNo,
    newPassword: sm2Encrypt(payload.newPassword),
  })
}
